"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default = exports.default = {
  directives: {
    permission: _index.default
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          id: '',
          uuid: '',
          addrType: '',
          addr1: '',
          addr2: '',
          addr3: '',
          city: '',
          state: '',
          postalCode: '',
          countryCode: '',
          billingInfo: {
            prefix: '',
            givenName: '',
            middleName: '',
            lastName: '',
            addr1: '',
            addr2: '',
            addr3: '',
            city: '',
            state: '',
            postalCode: '',
            countryCode: ''
          }
        };
      }
    }
  },
  data() {
    return {
      countryList: [],
      genderList: [],
      typeList: ['Home', 'Work', 'Other'],
      suffixList: ['', 'Sr.', 'Jr.', 'II', 'III'],
      prefixList: ['', 'Mr', 'Miss', 'Mrs', 'Ms', 'Dr', 'Prof', 'Sir', 'Lady'],
      me: {},
      isSame: false
    };
  },
  created() {
    console.log('page-user-acount-user', this.user);
    this.me = {
      id: this.user.id,
      uuid: this.user.uuid,
      addrType: this.user.addrType,
      addr1: this.user.addr1,
      addr2: this.user.addr2,
      addr3: this.user.addr3,
      city: this.user.city,
      state: this.user.state,
      postalCode: this.user.postalCode,
      countryCode: this.user.countryCode,
      billingInfo: this.user.billingInfo
    };
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
      this.genderList = this.$store.getters.genders;
    });
  },
  methods: {
    checkPermission: _permission.default,
    copyAddress() {
      if (this.isSame) {
        this.me.billingInfo.addr1 = this.me.addr1;
        this.me.billingInfo.addr2 = this.me.addr2;
        this.me.billingInfo.addr3 = this.me.addr3;
        this.me.billingInfo.city = this.me.city;
        this.me.billingInfo.state = this.me.state;
        this.me.billingInfo.postalCode = this.me.postalCode;
        this.me.billingInfo.countryCode = this.me.countryCode;
      } else {
        this.me.billingInfo.addr1 = '';
        this.me.billingInfo.addr2 = '';
        this.me.billingInfo.addr3 = '';
        this.me.billingInfo.city = '';
        this.me.billingInfo.state = '';
        this.me.billingInfo.postalCode = '';
        this.me.billingInfo.countryCode = '';
      }
    },
    save() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');

      // console.log('token', token)
      (0, _user.updateMyProfile)(token, this.me).then(response => {
        const data = response.data;
        // console.log('page-user-save', response)
        this.me.addrType = data.addrType;
        this.me.addr1 = data.addr1;
        this.me.addr2 = data.addr2;
        this.me.addr3 = data.addr3;
        this.me.city = data.city;
        this.me.state = data.state;
        this.me.postalCode = data.postalCode;
        this.me.countryCode = data.countryCode;
        this.me.billingInfo = data.billingInfo;
        (0, _log.displayPopupMessage)('User\' address information has been updated successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Update User Profile', email, `User Profile: ${data.uuid}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Page-user-Save-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};